import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userData: {
      id: '',
      role: '',
      name: '',
      email: ''
    },
    accessTokenExpDate: '',
    currentAlbum: [],

    // DOM constants
    windowWidth: 0,
    mobileMaxWidth: 320,
    tabletMaxWidth: 1024
  },

  actions: {},

  mutations: {
    SET_USER (state, accessTokenData) {
      state.userData = accessTokenData
    },
    SET_ATOKEN_EXP_DATE (state, expDate) {
      state.accessTokenExpDate = expDate
    },
    SET_CURRENT_ALBUM (state, list) {
      state.currentAlbum = list
    },
    SET_WINDOW_WIDTH (state, value) {
      state.windowWidth = value
    }
  },

  getters: {
    userData (state) {
      return state.userData
    },
    isMobile: (state) => state.windowWidth <= state.mobileMaxWidth,
    isTablet: (state) => (state.windowWidth <= state.tabletMaxWidth)
  },

  modules: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js